{
    "name": "cotagov-ui",
    "version": "1.3.0-SNAPSHOT",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --host 0.0.0.0 --disable-host-check",
        "build": "ng build",
        "build:dockerlocal": "ng build --configuration=dockerlocal",
        "build:dockerhomolog": "ng build --configuration=dockerhomolog",
        "build:prod": "ng build --configuration=production",
        "watch": "ng build --watch --configuration development",
        "format": "prettier --write \"**/*.{js,mjs,ts,mts,d.ts,html}\" --cache",
        "test": "ng test"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.0.0",
        "@angular/cdk": "^19.0.0",
        "@angular/common": "^19.0.0",
        "@angular/compiler": "^19.0.0",
        "@angular/core": "^19.0.0",
        "@angular/forms": "^19.0.0",
        "@angular/platform-browser": "^19.0.0",
        "@angular/platform-browser-dynamic": "^19.0.0",
        "@angular/router": "^19.0.0",
        "@bluehalo/ngx-leaflet": "^19.0.0",
        "@bluehalo/ngx-leaflet-draw": "^19.0.0",
        "@fortawesome/fontawesome-free": "^6.7.2",
        "@ngx-translate/core": "^16.0.4",
        "@ngx-translate/http-loader": "^16.0.1",
        "@primeng/themes": "^19.0.6",
        "chart.js": "4.4.2",
        "crypto-js": "^4.2.0",
        "jspdf": "^3.0.1",
        "jspdf-autotable": "^5.0.2",
        "leaflet": "^1.9.4",
        "leaflet-draw": "^1.0.2",
        "ngx-cookie-service": "^19.1.2",
        "ngx-extended-pdf-viewer": "^27.0.0",
        "primeclt": "^0.1.5",
        "primeicons": "^7.0.0",
        "primeng": "^19.0.8",
        "quill": "^2.0.3",
        "rxjs": "~7.8.0",
        "tailwindcss-primeui": "^0.5.1",
        "tslib": "^2.3.0",
        "xlsx": "^0.18.5",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.0.6",
        "@angular/cli": "^19.0.6",
        "@angular/compiler-cli": "^19.0.0",
        "@types/crypto-js": "^4.2.2",
        "@types/jasmine": "~5.1.0",
        "@types/leaflet": "^1.9.20",
        "@types/leaflet-draw": "^1.0.12",
        "@types/node": "^24.3.0",
        "autoprefixer": "^10.4.20",
        "eslint": "^9.14.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-import": "^2.31.0",
        "eslint-plugin-prefer-arrow": "^1.2.3",
        "eslint-plugin-prettier": "^4.2.1",
        "jasmine-core": "~5.4.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "postcss": "^8.4.49",
        "prettier": "^3.0.0",
        "tailwindcss": "^3.4.17",
        "typescript": "~5.6.2"
    }
}
